import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiErr } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Cross } from "lucide-react";

export default function ResetPassword() {
  const { L } = useLang();
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error(L("Password must be at least 6 characters", "Le mot de passe doit contenir au moins 6 caractères")); return; }
    if (pw !== pw2) { toast.error(L("Passwords do not match", "Les mots de passe ne correspondent pas")); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success(L("Password reset! Please sign in.", "Mot de passe réinitialisé ! Connectez-vous."));
      navigate("/");
    } catch (err) { toast.error(apiErr(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-md animate-fade-up">
        <div className="flex items-center gap-2 mb-8">
          <div className="h-10 w-10 rounded-lg bg-primary flex items-center justify-center"><Cross className="h-5 w-5 text-primary-foreground" /></div>
          <span className="font-heading font-extrabold text-primary">ICDH</span>
        </div>
        <h1 className="font-heading font-extrabold text-3xl tracking-tight">{L("Set a new password", "Nouveau mot de passe")}</h1>
        <p className="text-muted-foreground mt-2 mb-8">{L("Choose a new password for your account.", "Choisissez un nouveau mot de passe.")}</p>
        {!token ? (
          <p className="text-destructive" data-testid="reset-no-token">{L("Invalid or missing reset link.", "Lien de réinitialisation invalide.")}</p>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
            <div className="space-y-2"><Label>{L("New password", "Nouveau mot de passe")}</Label>
              <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-pw-input" /></div>
            <div className="space-y-2"><Label>{L("Confirm password", "Confirmer")}</Label>
              <Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-pw2-input" /></div>
            <Button type="submit" disabled={loading} className="w-full h-11" data-testid="reset-submit-btn">{loading ? "…" : L("Reset Password", "Réinitialiser")}</Button>
          </form>
        )}
      </div>
    </div>
  );
}
